import { useCallback, useContext, useState } from 'react';
import Box from '@mui/material/Box';
import useNRPaginatedQuery from '../../graphql/useNRPaginatedQuery';
import ActivityFeedContent from './NRActivityFeedContent';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { GET_ACTIVITY, GET_ACTIVITY_TOTAL_COUNT } from '../../graphql/queries/asset';

export const DEFAULT_PAGE_SIZE = 1000;

function NRActivityFeedContainer({ handleClose }) {
  const { asset } = useContext(ComponentContext);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState(1);

  const [assetActivity, loadingGetAssetActivity, fetchMore, pageInfo] = useNRPaginatedQuery({
    query: GET_ACTIVITY,
    options: {
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: DEFAULT_PAGE_SIZE },
          assetId: asset?.id
        }
      }
    },
    qlObjKey: 'activity',
    defaultValue: [],
    transformData: data => data?.map(item => item.node) ?? []
  });

  const [, , , , , activityTotalCount] = useNRPaginatedQuery({
    query: GET_ACTIVITY_TOTAL_COUNT,
    options: {
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 1 },
          assetId: asset?.id
        }
      }
    },
    qlObjKey: 'activity',
    defaultValue: null
  });

  const handleFetchMore = useCallback(
    ({ cursor, firstTime }) => {
      if (!firstTime) {
        if (cursor?.first) {
          setCurrentPage(prev => prev + 1);
        } else if (cursor?.last) {
          setCurrentPage(prev => Math.max(1, prev - 1));
        }
      }

      fetchMore({
        args: {
          assetId: asset?.id,
          cursor
        }
      });
    },
    [asset?.id, fetchMore]
  );

  const handleSetPageSize = useCallback(size => {
    setPageSize(size);
    setCurrentPage(1);
  }, []);

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ActivityFeedContent
        exportToCsvConfig={{
          qlArgs: {
            assetId: asset?.id
          }
        }}
        handleClose={handleClose}
        activity={assetActivity}
        isLoading={loadingGetAssetActivity}
        totalCount={activityTotalCount}
        pageInfo={pageInfo}
        pageSize={pageSize}
        currentPage={currentPage}
        handleFetchMore={handleFetchMore}
        handleSetPageSize={handleSetPageSize}
      />
    </Box>
  );
}
export default NRActivityFeedContainer;
